<template>
  <template v-if="!routerIsReady">
    Chargement...
  </template>
  <app-router-view v-else />
</template>

<script setup>
  import { onMounted } from 'vue'
  import 'src/services/session-expiration'
  import { useQuasar } from 'quasar'
  import dayjs from 'dayjs'
  import { useSessionFactory } from 'src/modules/core/composables/useSessionFactory.js'
  import { routerIsReady } from 'src/router/index.js'
  import { DEFAULT_LANGUAGE } from 'src/modules/language/composables/useUserLanguage.js'
  import { useDevice } from 'src/modules/core/composables/useDevice.js'
  import AppRouterView from 'src/modules/core/components/AppRouterView'

  const { isNativeCallAvailable, callNative } = useDevice()
  const languages = import.meta.glob('../node_modules/quasar/lang/(fr|en-US|ar).js')

  useSessionFactory()

  const $q = useQuasar()

  let language = localStorage.getItem('lang') || DEFAULT_LANGUAGE
  let locale = new Intl.Locale(language)
  const isoLanguage = language

  if (!localStorage.getItem('lang')) {
    localStorage.setItem('lang', language)
  }

  dayjs.locale(language)

  if (language === 'en') {
    language += '-US'
  }

  languages[`../node_modules/quasar/lang/${language}.js`]().then(lang => {
    $q.lang.set(lang.default)
    $q.lang.rtl = language === 'ar'
  })

  onMounted(() => {
    if (locale.textInfo) {
      document.documentElement.setAttribute('dir', locale.textInfo.direction ?? 'ltr')
    } else {
      document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr')
    }

    if (isNativeCallAvailable()) {
      callNative('setLanguage', JSON.stringify({ language: isoLanguage }), null)
    }
  })
</script>
